import { SHORT_PARCEL_NUMBER } from '../../constants/strings';
import { removeWhiteSpace } from '../../utils/string';

export const MIN_PARCEL_NUMBER_LENGTH = 9;

export const isValidNumber = (parcelNumber) =>
  removeWhiteSpace(parcelNumber).length < MIN_PARCEL_NUMBER_LENGTH;

export const validateParcelSearch = (parcelNumber) => {
  if (isValidNumber(parcelNumber)) {
    return SHORT_PARCEL_NUMBER;
  }
};
